// TourContext.js
import { createContext, useContext, useRef, useCallback, useEffect, useState } from "react"

const TourContext = createContext(null)

export const TourProvider = ({ children }) => {
    const refs = useRef({})
    const listeners = useRef(new Set())

    const registerRef = useCallback((id, el, onNext = null) => {
        if (!el) return
        if (refs.current[id]?.el === el) return
        refs.current[id] = { el, onNext }
        listeners.current.forEach(fn => fn())
    }, [])

    const getEntry = useCallback((id) => refs.current[id], [])

    const subscribe = useCallback((fn) => {
        listeners.current.add(fn)
        return () => listeners.current.delete(fn)
    }, [])

    // stable object — never changes, so no consumer re-renders
    const value = useRef({ registerRef, getEntry, subscribe }).current

    return (
        <TourContext.Provider value={value}>
            {children}
        </TourContext.Provider>
    )
}

export const useTour = () => {
    const ctx = useContext(TourContext)
    if (!ctx) throw new Error("useTour must be used inside TourProvider")
    return ctx
}